import React from 'react';
import {get} from 'lodash';
import className from 'classnames';
import axios from 'axios';

import {useCheckIds} from '../hooks';

import {
  requestCallback,
} from '../lib/helpers';

import Modal from './Modal';

const PostsListImageModal = ({
  post,
  isActive,
  onToggleModal,
  $submitButton,
}) => {
  const {
    checkIds,
    onCheck,
  } = useCheckIds({})

  const onSubmit = (e) => {
    e.preventDefault()

    if (checkIds.length > 0) {
      requestCallback(axios.get(`/${gon.currentProvider}/api/posts/${get(post, 'id')}/remove_attachments`, {
        params: {
          attachments: checkIds,
        }
      }))
    }
  }

  return (
    <Modal
      isActive={isActive}
      onToggleModal={onToggleModal}
    >
      <form onSubmit={onSubmit}>
        <h3 className='Modal__h3'>Delete images</h3>

        <div className='Posts__image-modal'>
          <div className='Posts__image-modal__wrapper'>
            {get(post, 'images', []).map((image, i) => (
              <a
                key={i}
                className='Posts__image-modal__a'
              >
                <img
                  src={get(image, 'url')}
                  onClick={onCheck(image)}
                />

                <span
                  className={className('CheckBox', {
                    'CheckBox--active': checkIds.find((id) => get(image, 'id') == id),
                  })}
                />
              </a>
            ))}
          </div>
        </div>

        <div className='Modal__footer Modal__footer--without-border'>
          <a
            className='Button Button--gray-light'
            onClick={onToggleModal}
          >
            Cancel
          </a>

          <button
            className='Button Button--blue'
            ref={$submitButton}
          >
            Delete
          </button>
        </div>
      </form>
    </Modal>
  );
}

export default PostsListImageModal;
